import axios from 'axios'

const state = {
	status: '',
	token: localStorage.getItem('token'),
	user: {},
	isLoggedIn: false
};

const getters = {
	authStatus: state => state.status
};

const mutations = {
	auth_request(state) {
		state.status = 'loading';
	},

	auth_success(state, data) {
		state.status = 'success';
		state.token = data.token;
		state.user = data.user;
		state.isLoggedIn = true;
	},

	auth_error(state) {
		state.token = '';
		state.status = '';
		state.isLoggedIn = false;
	},

	auth_sign_out(state) {
		state.token = '';
		state.status = '';
		state.isLoggedIn = false;
	},

	check_success(state, user) {
		state.status = 'verify sucess';
		state.user = user;
		state.isLoggedIn = true;
	},

	check_err(state) {
		state.status = 'error';
		state.isLoggedIn = false;
	},

	update_profile_picture(state, photo) {
		state.user.photo = photo;
	},

	update_password_status(state) {
		state.user.updatePassword = 0;
	},

	disable_user(state) {
		state.user.is_active = 0;
	}
};

const actions = {
	sign_in({commit}, data) {
		return new Promise((resolve, reject) => {
			commit('auth_request');
			axios.post(`${process.env.VUE_APP_ROOT_API}/user/sign_in`,{
					email: data.email,
					password: data.password
				})
				.then(response => {
					const token = response.data.token;
					const user = response.data.user;
					localStorage.setItem('token', token);
					commit('auth_success', {token, user});
					resolve(response);
				})
				.catch(err => {	
					commit('auth_error');
					localStorage.removeItem('token');
					reject(err);
				});
		});
	},

	signOut({commit}) {
		return new Promise((resolve, reject) => {
			axios.get(`${process.env.VUE_APP_ROOT_API}/user/sign_out`,{
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token')
					}
				})
				.then(response => {
					commit('auth_sign_out');
					localStorage.removeItem('token');
					resolve(response);
				})
				.catch(err => {
					reject(err);
				})
		});
	},

	chechAuth({commit}){
		return new Promise((resolve, reject) => {
			axios.get(`${process.env.VUE_APP_ROOT_API}/user/check`,{ 
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token')
					}
				})
				.then(response => {
					commit('check_success', response.data);
					resolve(response);
				})
				.catch(err => {
					localStorage.removeItem('token');
					commit('check_err');
					reject(err);
				})
		});
	},

	updatePassword({commit}) {
		commit('update_password_status');
	},

	disableUser({commit}) {
		commit('disable_user');
	}
};

export default {
	state,
	getters,
	mutations,
	actions
}

